import { render, staticRenderFns } from "./PageCatalogPreview.vue?vue&type=template&id=17b70a00&scoped=true&"
import script from "./PageCatalogPreview.vue?vue&type=script&lang=js&"
export * from "./PageCatalogPreview.vue?vue&type=script&lang=js&"
import style0 from "./PageCatalogPreview.vue?vue&type=style&index=0&id=17b70a00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b70a00",
  null
  
)

export default component.exports